// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 640px) {
  .side-menu-parent {
    width: 280px;
    min-width: 265px;
  }

  #lookanglesmultisite-menu {
    width: 450px;
  }

  #dops-menu {
    width: 400px;
  }

  #menu-satellite-collision,
  #FindSatPlugin-bottom-icon {
    display: inline;
  }

  .sat-info-value {
    width: 65%;
  }

  footer {
    margin-top: -100px;
    position: absolute;
    bottom: 0px;
    height: 120px;
    width: 100%;
  }

  #bottom-icons-container {
    width: 100%;
    height: var(--bottom-menu-height);
  }

  #footer-toggle-wrapper {
    width: 100%;
    /* bottom: 120px; */
    z-index: 1;
    position: relative;
  }

  .footer-slide-down {
    bottom: -115px !important;
    height: 120px !important;
    top: auto !important;
  }

  .footer-slide-trans {
    transition: 1s;
  }

  .footer-slide-up {
    bottom: 0px !important;
    top: auto !important;
  }

  .ui-timepicker-div dl dd div {
    width: 150px !important;
  }

  #datetime-text {
    border-width: 0px 0px 0px 1px;
    border-style: solid;
    border-color: var(--color-dark-text-accent);
    padding: 0px 10px 0px 10px;
    vertical-align: bottom;
  }

  #jday {
    display: block;
  }

  #toast-container {
    min-width: 0px;
    right: 5%;
  }

  .sat-infobox-links {
    display: block;
    justify-content: flex-start;
    text-align: unset;
  }

  #sat-infobox {
    bottom: var(--bottom-menu-height);
    width: 70%;
    max-width: 380px;
    right: 0px;
  }

  #polar-plot {
    width: 95%;
  }

  #sensor-timeline-sensor-list,
  #multi-site-look-angles-sensor-list {
    display: grid;
    justify-content: space-evenly;
    justify-items: stretch;
    grid-row-gap: 10px;
    grid-column-gap: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./public/css/responsive-sm.css"],"names":[],"mappings":"AAAA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW;EACb;;EAEA;IACE,WAAW;IACX,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;IACnB,2CAA2C;IAC3C,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,cAAc;IACd,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;IACjC,UAAU;IACV,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,aAAa;IACb,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;EACvB;AACF","sourcesContent":["@media (min-width: 640px) {\n  .side-menu-parent {\n    width: 280px;\n    min-width: 265px;\n  }\n\n  #lookanglesmultisite-menu {\n    width: 450px;\n  }\n\n  #dops-menu {\n    width: 400px;\n  }\n\n  #menu-satellite-collision,\n  #FindSatPlugin-bottom-icon {\n    display: inline;\n  }\n\n  .sat-info-value {\n    width: 65%;\n  }\n\n  footer {\n    margin-top: -100px;\n    position: absolute;\n    bottom: 0px;\n    height: 120px;\n    width: 100%;\n  }\n\n  #bottom-icons-container {\n    width: 100%;\n    height: var(--bottom-menu-height);\n  }\n\n  #footer-toggle-wrapper {\n    width: 100%;\n    /* bottom: 120px; */\n    z-index: 1;\n    position: relative;\n  }\n\n  .footer-slide-down {\n    bottom: -115px !important;\n    height: 120px !important;\n    top: auto !important;\n  }\n\n  .footer-slide-trans {\n    transition: 1s;\n  }\n\n  .footer-slide-up {\n    bottom: 0px !important;\n    top: auto !important;\n  }\n\n  .ui-timepicker-div dl dd div {\n    width: 150px !important;\n  }\n\n  #datetime-text {\n    border-width: 0px 0px 0px 1px;\n    border-style: solid;\n    border-color: var(--color-dark-text-accent);\n    padding: 0px 10px 0px 10px;\n    vertical-align: bottom;\n  }\n\n  #jday {\n    display: block;\n  }\n\n  #toast-container {\n    min-width: 0px;\n    right: 5%;\n  }\n\n  .sat-infobox-links {\n    display: block;\n    justify-content: flex-start;\n    text-align: unset;\n  }\n\n  #sat-infobox {\n    bottom: var(--bottom-menu-height);\n    width: 70%;\n    max-width: 380px;\n    right: 0px;\n  }\n\n  #polar-plot {\n    width: 95%;\n  }\n\n  #sensor-timeline-sensor-list,\n  #multi-site-look-angles-sensor-list {\n    display: grid;\n    justify-content: space-evenly;\n    justify-items: stretch;\n    grid-row-gap: 10px;\n    grid-column-gap: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
